// Componente padre principal de la sub-página de Encuestas
// ============
// Importaciones de React
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// Importaciones de Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  guardarDatosEncuesta,
  cambiarEstadoPagina,
  obtenerDatosEncuesta,
  actualizarHashEncuesta
} from '../../store/actions/encuestas';
// ============
import classes from './EncuestasPrincipal.css';
// Importaciones de componentes complementarios
import FormularioEncuesta from './formularioEncuesta/formularioEncuesta';
import MensajeInfoerror from './MensajeInfoerror/MensajeInfoerror';
import BotonEnviar from '../../components/Encuestas/BotonEnviar/BotonEnviar';
// JSONs locales para pruebas
/*import encuestaTestA from './JSONlocalesDePrueba/encuestaTestA.json';
import encuestaTestB from './JSONlocalesDePrueba/encuestaTestB.json';
import encuestaTestC from './JSONlocalesDePrueba/encuestaTestC.json';
import encuestaTestD from './JSONlocalesDePrueba/encuestaTestC.json';
import encuestaTestE from './JSONlocalesDePrueba/encuestaTestE.json'*/ // Componente principal
const EncuestasPrincipal = () => {
  // Declaración de estado y constantes
  const location = useLocation();
  const dispatch = useDispatch();
  const estadoPagina = useSelector((state) => state.encuestas.estadoPagina);
  const datosEncuesta = useSelector((state) => state.encuestas.datosEncuesta);
  const detalleEnvio = useSelector((state) => state.encuestas.detalleEnvio);

  /*console.log("estadoPagina vale:"); console.log(estadoPagina); console.log("datosEncuesta vale:"); console.log(datosEncuesta); console.log("detalleEnvio vale:"); console.log(detalleEnvio); console.log("contenidoEnvio vale:"); console.log(contenidoEnvio);*/

  // Extraer hash e información desde la URL
  const queryParams = new URLSearchParams(location.search);
  //const hash = "5B5974EF-2F21-4D8F-B8F8-2A60EFCF9DEG" <-- Forzar un hash, para testeo
  const hash = queryParams.get('hash');
  dispatch(actualizarHashEncuesta(hash));
  // Fetch inicial
  useEffect(() => {
    dispatch(obtenerDatosEncuesta(hash)); // Pasar el hash a la acción en Redux
    //cargarJSON(encuestaTestC); //<-- Cargar un JSON local, para testeo
  }, [dispatch, hash]);
  const [mensajeErrorMail, setMensajeErrorMail] = useState('');
  const [objetoFetchMail, setObjetoFetchMail] = useState('');
  // Esto se usa para hacer fetchs vía mail
  const nombre = queryParams.get('nombre');
  const apellido = queryParams.get('apellido');
  const satisfaccion = queryParams.get('satisfaccion');
  const conformidad = queryParams.get('conformidad');
  const atencion = queryParams.get('atencion');
  const extra = queryParams.get('extra');

  useEffect(() => {
    // Con este useEffect determinamos si:
    // A) Estamos cargando los datos de la encuesta -ya respondida- desde un mail
    // B) Tenemos que cargar los datos de una encuesta -respondida o no- desde un hash

    if (location.pathname === '/encuestas/mail') {
      // A) Si estamos cargando la encuesta desde un mail, primero revisamos si recivimos todos los datos
      if (nombre && apellido && satisfaccion && conformidad && atencion && hash) {
        // Si están todos los datos, estamos en condiciones de enviar los resultados al servidor
        //console.log('Se hace el fetch');
        // Creamos el objeto con los datos que se van a enviar
        setObjetoFetchMail({
          hash: hash,
          encuestaId: 3,
          nombreUsuario: nombre,
          apellidoUsuario: apellido,
          respuestasPreguntas: [
            {
              encuestaPreguntaId: 8,
              encuestaPreguntaOpcionId: 23,
              valor: satisfaccion
            },
            {
              encuestaPreguntaId: 9,
              encuestaPreguntaOpcionId: 27,
              valor: atencion
            },
            {
              encuestaPreguntaId: 10,
              encuestaPreguntaOpcionId: 33,
              valor: conformidad
            },
            {
              encuestaPreguntaId: 11,
              encuestaPreguntaOpcionId: 11,
              valor: extra
            }
          ]
        });
        // Vamos a cargar la página correspondiente
        dispatch(cambiarEstadoPagina(5));
      } else {
        const camposFaltantes = [];
        if (!nombre) camposFaltantes.push('nombre');
        if (!apellido) camposFaltantes.push('apellido');
        if (!satisfaccion) camposFaltantes.push('satisfacción');
        if (!conformidad) camposFaltantes.push('conformidad');
        if (!atencion) camposFaltantes.push('atención');
        if (!hash) camposFaltantes.push('hash');

        setMensajeErrorMail(`${camposFaltantes.join(', ')}`);
        //console.log('Faltan datos');
        //console.log(mensajeErrorMail);

        dispatch(cambiarEstadoPagina(6));
      }
    } else {
      dispatch(obtenerDatosEncuesta(hash));
    }
  }, [dispatch, hash, location.pathname, nombre, apellido, satisfaccion, conformidad, atencion]);

  // Función de testeo para cargar JSON locales
  const cargarJSON = (datos) => {
    dispatch(guardarDatosEncuesta(datos));
    dispatch(cambiarEstadoPagina(1));
  };

  // Return del componente
  return (
    <div className={classes.fondoGeneral}>
      <div className={classes.card}>
        <div className={classes.inner}>
          {/* estadoPagina:
                               0 = Cargando encuesta
                               1 = La encuesta en si
                               2 = Error al cargar la encuesta 
                               3 = Mensaje que se muestra al enviar la encuesta de regreso de forma exitosa
                               4 = Mensaje que se muestra cuando ocurre un error al enviar la encuesta de regreso
                               5 = Enviamos las respuestas desde un mail
                               6 = Error de falta de datos para poder enviar las respuestas desde un mail
                          */}
          {estadoPagina === 0 && (
            <>
              {(() => {
                const mensaje = {
                  titulo: 'Cargando encuesta...',
                  texto1: 'Por favor espere',
                  imagen: 0
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
          {estadoPagina === 1 && <FormularioEncuesta datos={datosEncuesta} />}
          {estadoPagina === 2 && (
            <>
              {(() => {
                const textoError = datosEncuesta?.error ? datosEncuesta.error : 'Sin datos';
                const mensaje = {
                  titulo: '¡Ups!',
                  texto1: 'No se pudo cargar la encuesta',
                  error: { texto: textoError, color: 'red' },
                  texto2: 'Por favor, intenta nuevamente más tarde',
                  imagen: 1
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
          {estadoPagina === 3 && (
            <>
              {(() => {
                const mensaje = {
                  titulo: '¡Encuesta respondida!',
                  texto1: 'Gracias por tu feedback',
                  texto2: datosEncuesta?.encuesta?.cierre ? datosEncuesta?.encuesta?.cierre : '',
                  imagen: 2
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
          {estadoPagina === 4 && (
            <>
              {(() => {
                const textoEnvio = detalleEnvio ? detalleEnvio : 'Sin datos';
                const mensaje = {
                  titulo: '¡Ups!',
                  texto1: 'No se pudo enviar la encuesta',
                  error: { texto: textoEnvio, color: 'red' },
                  mostrarBotonReenviar: true,
                  imagen: 1
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
          {estadoPagina === 5 && (
            <>
              {(() => {
                const mensaje = {
                  titulo: `¡Yay!`,
                  texto1: (
                    <>
                      <BotonEnviar enviarDirecto={true} objetoListo={objetoFetchMail} />
                    </>
                  ),
                  mostrarBotonReenviar: false,
                  imagen: 1
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
          {estadoPagina === 6 && (
            <>
              {(() => {
                const mensaje = {
                  titulo: `¡Un momento!`,
                  texto1: `No se pudieron enviar las respuestas porque faltan estos datos: ${mensajeErrorMail}. Volvé al mail, completalos y enviá la encuesta de vuelta :)`,
                  mostrarBotonReenviar: false,
                  imagen: 1
                };
                return <MensajeInfoerror mensaje={mensaje} />;
              })()}
            </>
          )}
        </div>
        <div className={classes.pie}>
          <strong>¡Muchas gracias por tu opinión!</strong>
          <small>Equipo de Gauss Sistemas</small>
        </div>
      </div>
    </div>
  );
};

export default EncuestasPrincipal;
